import { ENDPOINT_ROUTES, BASE_URL } from "./routes";
import $ from "jquery";

const TEMPLATES_URL = BASE_URL + ENDPOINT_ROUTES.offers + "/templates";

function resolveError(xhr) {
  if (xhr.status === 0) {
    return navigator.onLine
      ? "Nie można połączyć się z serwerem."
      : "Brak połączenia z Internetem.";
  }

  if (xhr.responseText) return xhr.responseText;

  return "Wystąpił nieznany błąd.";
}

const api = {
  // GET /offers/templates — lekka lista szablonów (bez form_data)
  list: (callback) => {
    $.ajax({
      url: TEMPLATES_URL,
      type: "GET",
      contentType: "application/json; charset=utf-8",
      success: function (response) {
        callback({ success: true, content: response });
      },
      error: function (xhr) {
        callback({ success: false, error: resolveError(xhr) });
      },
    });
  },

  // GET /offers/templates/:id — pełny szablon (rozwinięte form_data + metadane)
  getById: (id, callback) => {
    $.ajax({
      url: TEMPLATES_URL + "/" + id,
      type: "GET",
      contentType: "application/json; charset=utf-8",
      success: function (response) {
        callback({ success: true, content: response });
      },
      error: function (xhr) {
        callback({ success: false, error: resolveError(xhr) });
      },
    });
  },

  // POST /offers/templates — utworzenie szablonu (form_data + wymagane name)
  create: (formData, callback) => {
    $.ajax({
      url: TEMPLATES_URL,
      type: "POST",
      data: JSON.stringify(formData),
      contentType: "application/json; charset=utf-8",
      success: function (response) {
        callback({ success: true, content: response });
      },
      error: function (xhr) {
        callback({ success: false, error: resolveError(xhr) });
      },
    });
  },

  // PUT /offers/templates/:id — edycja szablonu (bump wersji)
  update: (id, formData, callback) => {
    $.ajax({
      url: TEMPLATES_URL + "/" + id,
      type: "PUT",
      data: JSON.stringify(formData),
      contentType: "application/json; charset=utf-8",
      success: function (response) {
        callback({ success: true, content: response });
      },
      error: function (xhr) {
        callback({ success: false, error: resolveError(xhr) });
      },
    });
  },

  // DELETE /offers/templates/:id — usunięcie szablonu (kopia do Trash)
  remove: (id, callback) => {
    $.ajax({
      url: TEMPLATES_URL + "/" + id,
      type: "DELETE",
      success: function (response) {
        callback({ success: true, content: response });
      },
      error: function (xhr) {
        callback({ success: false, error: resolveError(xhr) });
      },
    });
  },

  // GET /offers/templates/:id/versions — historia rewizji (bez form_data)
  getVersions: (id, callback) => {
    $.ajax({
      url: TEMPLATES_URL + "/" + id + "/versions",
      type: "GET",
      contentType: "application/json; charset=utf-8",
      success: function (response) {
        callback({ success: true, content: response });
      },
      error: function (xhr) {
        callback({ success: false, error: resolveError(xhr) });
      },
    });
  },

  // GET /offers/templates/:id/versions/:revision — snapshot konkretnej rewizji
  getVersion: (id, revision, callback) => {
    $.ajax({
      url: TEMPLATES_URL + "/" + id + "/versions/" + revision,
      type: "GET",
      contentType: "application/json; charset=utf-8",
      success: function (response) {
        callback({ success: true, content: response });
      },
      error: function (xhr) {
        callback({ success: false, error: resolveError(xhr) });
      },
    });
  },

  // POST /offers/templates/:id/versions/:revision/restore — przywrócenie rewizji
  restoreVersion: (id, revision, callback) => {
    $.ajax({
      url: TEMPLATES_URL + "/" + id + "/versions/" + revision + "/restore",
      type: "POST",
      contentType: "application/json; charset=utf-8",
      success: function (response) {
        callback({ success: true, content: response });
      },
      error: function (xhr) {
        callback({ success: false, error: resolveError(xhr) });
      },
    });
  },
};

const offerTemplatesApi = { api };

export default offerTemplatesApi;
